<template>
  <div class="postal-code-component" v-invalid="validation.is_valid">
    <div class="field" :class="getFieldClass(field.layout.layout_type)">
      <div class="control" :class="getControlClass(field.layout.layout_type)">
        <b-field :label="field.label"
                 @keyup.native="removeValidation()">
            <b-autocomplete
                v-model="formData.fields[field.id].value"
                :keep-first="false"
                :select-on-click-outside="true"
                :open-on-focus="false"
                :data="filteredDataObj"
                field="value"
                @select="option => (onSelect(option))"
                :clearable="false"
            >
              <template slot-scope="props">
                {{ props.option.text }},
              </template>
            </b-autocomplete>
        </b-field>

        <p class="help is-danger"
           v-if="!validation.is_valid" v-translate>
          {{ validation.message }}
        </p>
        <p class="help"
           v-if="field.properties.help_text"
           v-html="field.properties.help_text">
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import FormField from '@/classes/form/FormField'
  import FormData from '@/classes/form/FormData'
  import { mapActions } from 'vuex'

  export default {
    name: 'text-postal-code-component',
    data () {
      return {
        available_options: null,
        selected: false,
        setReadOnlyFieldIds: [],
        last_data: ''
      }
    },
    props: {
      field: {
        type: FormField
      },
      formData: {
        type: FormData
      },
      showLabel: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      validation () {
        return this.formData.validations[this.field.id] || { is_valid: true }
      },
      filteredDataObj () {
        if (!this.available_options) {
          return []
        }
        return this.available_options.filter(option => {
          return (
            option.value
              .toString()
              .toLowerCase()
              .indexOf(this.formData.fields[this.field.id].value.toLowerCase()) >= 0
          )
        })
      }
    },
    methods: {
      ...mapActions([
        'getPostalCodeSuggestions'
      ]),
      getSuggestions () {
        let value = this.formData.fields[this.field.id].value
        if (value && value.length >= 3) {
          value = value.replace(/\s/, '')
          this.getPostalCodeSuggestions(value).then((result) => {
            this.available_options = result
          })
        }
        this.available_options = null
      },
      onSelect (option) {
        if (option === null) {
          this.selected = false
          return
        }
        this.formData.fields[this.field.id].value = option.value
        console.log(this.formData.fields[this.field.id].value)
        let additionalFields = option.additional_fields
        for (let [key, value] of Object.entries(additionalFields)) {
          let insertFieldId = this.field.id.replace(/@.*?#/, '@' + key + '#')
          this.formData.fields[insertFieldId].value = this.formatValue(value)
          this.setReadOnlyFieldIds.push(insertFieldId)
        }
        this.selected = true
      },
      formatValue (value) {
        return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
      },
      deleteReadOnlyFields () {
        this.setReadOnlyFieldIds.forEach((fieldId) => {
          this.formData.fields[fieldId].value = null
        })
        this.setReadOnlyFieldIds = []
      },
      removeValidation () {
        let value = this.formData.fields[this.field.id].value
        if (value !== this.last_data) {
          this.validation.is_valid = true
          if (value.length !== 5) {
            this.selected = false
            this.deleteReadOnlyFields()
          }
          this.getSuggestions()
        }
        this.last_data = value
      },
      getFieldClass: function (layoutType) {
        return {
          'columns is-multiline is-mobile': layoutType === 'horizontal'
        }
      },
      getLabelClass: function (layoutType) {
        return {
          'column is-4': layoutType === 'horizontal'
        }
      },
      getControlClass: function (layoutType) {
        return {
          'column is-8': layoutType === 'horizontal'
        }
      },
      getInputClass: function (isValid) {
        return {
          'is-danger': !isValid
        }
      }
    }
  }
</script>

<style lang="sass" scoped>
  label > li
    list-style-position: inside
</style>
